import React from "react";
import { Form, Input, Select } from "antd";
import { InputMask } from "@mtm/components";
import styles from "./PersonForm.module.scss";
import { selectDropdownArrowIcon } from "../../../assets/images";
import { useServiceUserCreationCtx } from "../../../context/ServiceUserCreationContext";

function ContactDetails() {
  const { relationshipTypesCtx } = useServiceUserCreationCtx();
  const [relationshipTypes] = relationshipTypesCtx;
  return (
    <>
      <Form.Item name="firstName">
        <Input
          maxLength={100}
          placeholder="First Name"
          className={styles.tcInput}
        />
      </Form.Item>

      <Form.Item name="lastName">
        <Input
          maxLength={100}
          placeholder="Last Name"
          className={styles.tcInput}
        />
      </Form.Item>

      <Form.Item name="phone">
        <InputMask
          className={styles.tcInput}
          mask="999-999-9999"
          maskPlaceholder=""
          placeholder="Phone Number"
          onChange={() => {}}
        />
      </Form.Item>

      <Form.Item name="email">
        <Input placeholder="Email" className={styles.tcInput} />
      </Form.Item>

      <Form.Item name="relationship">
        <Select
          className={styles.tcRelationshipSelect}
          placeholder="Relationship"
          suffixIcon={
            <img src={selectDropdownArrowIcon} alt="select_reason_dropdown" />
          }
          options={relationshipTypes}
        />
      </Form.Item>
    </>
  );
}

export default ContactDetails;
